<div class="maptile-nearby">
    <div class="config-tab-title-area">
        <smart-icon name="filter-o" class="light"></smart-icon>
        <span class="h3-regular config-tab-title">{{'dashboard.filter_your_data' | stringLiterals}}</span>
    </div>
    <div class=" maptile-body">
        <div class="maptile-nearby-search">
            <span class="body-1">{{'general.show_nearby_entity_contacts' |stringLiterals }}</span>
            <kendo-dropdownlist #dropDownEl [data]="radiusData" (valueChange)="radiusValuChange($event)"
                [(ngModel)]="radiusSelect" style="width: 100%" [textField]="'name'" [valueField]="'value'">
            </kendo-dropdownlist>
            <div class="div-entity-dropdown">
                <multi-sel-dropdown-filter [dropdownConfig]='entityTypeConfig'>
                    <ng-template #multiCustomContent>
                        <div class="selected-entityType text-ellipsis" (click)='onClickEntity($event)'>
                            {{entityName}}
                        </div>
                    </ng-template>
                </multi-sel-dropdown-filter>
            </div>
            <!--relationship fitler-->
            <multi-sel-dropdown-filter [dropdownConfig]="relationshipDropdownConfig" *ngIf="entityName !== 'None'">
                <ng-template #multiCustomContent>
                    <div class="relationship-row">
                        <span
                            [ngClass]="{'relationship-text-unclick': selectedRelationships && selectedRelationships.length > 0,'relationship-text-click': !selectedRelationships || selectedRelationships.length == 0}"
                            (click)="onClickRelationship($event, 1)">{{btnText}}</span>
                        <span class="relationship-click"
                            (click)="onClickRelationship($event)">{{relationshipNames}}</span>
                        <smart-icon name="trash" (click)="onClickRemoveRelationshipClicked()"
                            *ngIf="selectedRelationships && selectedRelationships.length > 0"></smart-icon>
                    </div>
                </ng-template>
            </multi-sel-dropdown-filter>
        </div>
        <!--filter part-->
        <div class="map-filter">
            <!--contact filter-->
            <fieldset *ngIf="isShowContactFilter&&filterConfig&&filterConfig.filtersConfigList">
                <legend>{{'general.contact_filters' |stringLiterals }}</legend>
                <div class="filter-area">
                    <filter-panel [config]="filterConfig"></filter-panel>
                    <div class="control">
                        <tam-field-selector [config]="fieldConfig">
                            <ng-template #customBtn>
                                <span class="add-filter-btn hover-link">{{'general.add_contact_filter' |stringLiterals
                                    }}</span>
                            </ng-template>
                        </tam-field-selector>
                    </div>
                </div>
            </fieldset>
            <!--entity filter-->
            <fieldset *ngIf="isShowEntityFilter&&filterEntityConfig&&filterEntityConfig.filtersConfigList">
                <legend>{{'general.entity_filters' |stringLiterals }}</legend>
                <div class="filter-area">
                    <filter-panel [config]="filterEntityConfig"></filter-panel>
                    <div class="control">
                        <tam-field-selector *ngIf="fieldEntityConfig" [config]="fieldEntityConfig">
                            <ng-template #customBtn>
                                <span class="add-filter-btn hover-link">{{'general.add_entity_filter' |stringLiterals
                                    }}</span>
                            </ng-template>
                        </tam-field-selector>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</div>